import {Card, CardContent, CardHeader, CardMedia, Chip, Grid, Paper, Typography} from "@mui/material";
import {TimeLineOrdenComponent} from "./TimeLine";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Divider from "@mui/material/Divider";
import bus from '../img/bus.png';


const PIECES = [
    {label: "Pieza 1", id: 1},
    {label: "Pieza 2", id: 2},
    {label: "Pieza 3", id: 3},
    {label: "Pieza 4", id: 4},
    {label: "Pieza 5", id: 5},
    {label: "Pieza 6", id: 6},
    {label: "Pieza 7", id: 7},
    {label: "Pieza 8", id: 8},
    {label: "Pieza 9", id: 9},
    {label: "Pieza 10", id: 10},
    {label: "Pieza 11", id: 11},
    {label: "Pieza 12", id: 12},
    {label: "Pieza 13", id: 13},
];

export function InformationUnitComponet({dataUnit}){

    return(
        <Card>
            <CardHeader
                title={dataUnit.unidad}
                subheader={`Fecha de entrada: ${dataUnit.date_in}`}
                action={
                    <IconButton aria-label="settings">
                        <MoreVertIcon/>
                    </IconButton>
                }
            />
            <CardMedia
                component="img"
                height="410"
                image={bus}
                alt="imagen de camion"
            />
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TimeLineOrdenComponent select={2}/>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography>Piezas: </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper elevation={6} style={{padding: "1vh"}}>
                            {
                                PIECES.map(piece=>(
                                     <Chip style={{margin: "1vh"}} key={`pieza-${piece.id}`} label={piece.label}/>
                                ))
                            }
                        </Paper>
                    </Grid>

                </Grid>




            </CardContent>
        </Card>
    );
}